import HowToPage from './how-to'
export default HowToPage
